<template>
  <div class="subscribe-block">
    <h5>Subscribe to our newsletter.</h5>
    <form @submit.stop.prevent="submit" style="text-align: center;">
      <input
        type="email"
        placeholder="Enter your email here"
        v-model.trim="email"
        :class="error ? 'errors' : ''"
        :disabled="isSending"
        autocomplete="email"
      />
      <input type="submit" :value="isSending ? 'Subscribing...' : 'Subscribe'" :disabled="isSending" />
      <div>
        <span style="width: 100%;" class="text-danger float-right" v-if="error">{{ error }}</span>
      </div>
      <b-alert style="width: 100%;" v-if="success" show dismissible variant="success">
        {{ success }}
      </b-alert>
      <b-alert style="width: 100%;" v-if="failure" show dismissible variant="danger">
        {{ failure }}
      </b-alert>
    </form>
  </div>
</template>

<script>
/**
 * Newsletter subscribe box.
 *
 * One component instead of the four identical copies that used to live in Homepage,
 * MerchantForm, MerchantExtended and MerchantAgreement - all of which shared the same two
 * defects:
 *
 *   - a failure was reported in a GREEN "success" alert, because both branches set the
 *     same flag;
 *   - errors were written into an array with `errors['subscribe_email'] = ...`, which
 *     Vue 2 cannot make reactive, so the validation message often never appeared.
 *
 * The welcome email is sent by the BACKEND when POST /v1/subscription is handled. The
 * browser cannot speak SMTP, so all this does is submit the address and report whatever
 * the server says.
 */
import { mapActions } from "vuex";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export default {
  name: "SubscribeForm",
  props: {
    /** Recorded on the admin notification so you can tell the pages apart. */
    source: { type: String, default: "Website footer" },
  },
  data() {
    return { email: "", error: "", success: "", failure: "", isSending: false };
  },
  methods: {
    ...mapActions(["submitSubscriber"]),

    submit() {
      this.error = "";
      this.success = "";
      this.failure = "";

      const address = String(this.email || "").trim();
      if (!address) { this.error = "Please enter your email address."; return; }
      if (!EMAIL_RE.test(address)) { this.error = "Please enter a valid email address."; return; }

      this.isSending = true;
      const vm = this;
      const form = new FormData();
      form.append("email", address);
      // Which page the address came from, so the backend can tell them apart.
      form.append("source", this.source);

      // The action's RETURN value is used rather than the shared successmessage /
      // errormessage flags. Those are global and any other action can overwrite them
      // between the request going out and the answer arriving, which is exactly how a
      // failure once ended up shown as a success.
      return this.submitSubscriber(form).then(function (res) {
        vm.isSending = false;
        if (res && res.ok) {
          vm.email = "";
          vm.success = res.message || "You are subscribed. Thank you!";
          return;
        }
        vm.failure = (res && res.message) ||
          "We could not add that address. Please try again.";
      }).catch(function () {
        vm.isSending = false;
        vm.failure = "We could not add that address. Please try again.";
      });
    },
  },
};
</script>

<style scoped>
.subscribe-block { width: 100%; }
</style>
